export enum PATH {
  HOME = '/',
  RULES = '/rules',
  WINNERS = '/winners',
  SUPPORT = '/support',
}

export const menuItems = [
  { path: PATH.HOME, label: 'MAMA.MENU.REGISTRATION', bold: true },
  { path: PATH.RULES, label: 'MAMA.MENU.RULES', bold: true },
  { path: PATH.WINNERS, label: 'MAMA.MENU.WINNERS', bold: true },
  { path: PATH.SUPPORT, label: 'MAMA.MENU.SUPPORT', bold: true },
];
